/**
 * Constants for battlemap interactions
 * Consolidates magic numbers scattered throughout the codebase
 */

// Fog-related constants
export const FOG_SIZE = 3000;
export const FOG_FILL_RESOLUTION = 10;

// Handle and UI sizing
export const HANDLE_SIZE = 8;
export const HANDLE_HIT_SIZE = 10;
export const MIN_SHAPE_SIZE = 10;
export const DRAG_TOLERANCE = 5;
export const MIN_TEXT_WIDTH = 50;

// Drawing thresholds
export const BRUSH_THICKNESS = 5; // fog brush minimum distance
export const DRAW_BRUSH_THICKNESS = 2; // draw brush minimum distance
export const BRUSH_MIN_DISTANCE = 5;
export const DRAW_BRUSH_MIN_DISTANCE = 2;
export const POLYGON_CLOSE_DISTANCE = 20;
export const MIN_RECT_SIZE = 5;
export const POLYGON_MIN_POINTS = 6; // 3 points (6 coordinates)

// Text sizing
export const TEXT_WIDTH_MULTIPLIER = 0.6;
export const TEXT_HEIGHT_RATIO = 1.2;
export const DEFAULT_FONT_SIZE = 24;
export const DEFAULT_TEXT_WIDTH = 200;

// Selection colors
export const SELECTION_COLOR = 0x00aaff;
export const SELECTION_FILL_ALPHA = 0.1;
export const SELECTION_STROKE_WIDTH = 2;
export const MARQUEE_FILL_ALPHA = 0.2;
export const MARQUEE_STROKE_ALPHA = 0.8;

// Fog colors and alphas
export const FOG_HIDE_FILL_COLOR = 0x000000;
export const FOG_REVEAL_FILL_COLOR = 0xffffff;
export const FOG_HIDE_STROKE_COLOR = 0xffffff;
export const FOG_REVEAL_STROKE_COLOR = 0xff0000;
export const FOG_FILL_ALPHA = 0.5;
export const FOG_STROKE_ALPHA = 0.8;
export const FOG_BRUSH_ALPHA = 0.3;
export const FOG_BRUSH_STROKE_WIDTH = 2;

// Room defaults
export const DEFAULT_ROOM_COLOR = "#3b82f6";

// Handle identifiers
export const HANDLE_TOP_LEFT = "tl";
export const HANDLE_TOP_RIGHT = "tr";
export const HANDLE_BOTTOM_LEFT = "bl";
export const HANDLE_BOTTOM_RIGHT = "br";

// Default text content
export const DEFAULT_TEXT_CONTENT = "Double click to edit";

// Default drawing values
export const DEFAULT_STROKE_COLOR = "#ff0000";
export const DEFAULT_FILL_COLOR = "#ffffff";
export const DEFAULT_FILL_ALPHA = 0;
export const DEFAULT_DRAW_FILL_ALPHA = 0.1;
export const DEFAULT_STROKE_WIDTH = 2;
